import React, { useContext, useEffect, useState } from 'react'
import { Image, Text } from '../../../designSystem'
import { Stats, Timer } from '../Cards/monthlyBookCard'
import { get } from '../../../lib/api'
import { checkOverseasUser, handleEventLog } from '../../../lib/utils'
import {
  AuthorName,
  BookCard,
  BookTitle,
  DetailsDiv,
  title,
  TopSection,
} from '../style'
import { menuItemObj } from '../../../components/PrivatePage'
import CautionNote from './CautionNote'
import ActionButtons from './ActionButtons'
import DailyBonusCard from './DailyBonusCard'
import ProgressBar from './ProgressBar'
import { AccountContext } from '../../../providers/accountProvider'
import CountryPopup from './CountryPopup'
import AlertSnackBar from '../../../components/AlertSnackBar'
import PerformanceCard from '../Cards/performanceCard'
import SeriesPerformanceCard from '../Cards/seriesPerformanceCard'

const NewBookCards = ({
  bookDetails,
  author_name,
  history,
  viewApplication,
  novelApply,
  signingStatus,
}) => {
  const { user, onUpdateUser } = useContext(AccountContext)
  const isPublished =
    bookDetails?.status === 'published' || bookDetails?.status === 'approved'
  const isOngoing = bookDetails?.application_status === 'ongoing'
  const isNotApplied = bookDetails?.application_status === 'not_applied'
  const isPending = bookDetails?.application_status === 'pending'
  const isRejected = bookDetails?.application_status === 'rejected'
  const isCreated = bookDetails?.application_status === 'created'
  const isEligible = bookDetails?.application_status === 'eligible'
  const isApproved = bookDetails?.application_status === 'approved'
  const dateCheck =
    new Date(bookDetails.create_time) - new Date(2022, 7, 2) >= 0
  const isLanguageNotAllowedForWBP = !['hindi', 'tamil', 'english'].includes(
    bookDetails.language
  )
  const isNonIndianAndNonUSUser =
    checkOverseasUser(user) && user?.languages !== 'english'
  const [dailyBonusData, setDailyBonusData] = useState(null)
  const [isCountryPopupOpen, toggleCountryPopup] = useState(false)
  const [applySnack, toggleApplySnack] = useState(false)
  const eligibleForIncentive = !!bookDetails?.eligible_for_incentive

  useEffect(() => {
    eligibleForIncentive &&
      get(
        `/content_api/book.wbp_daily_incentive/${bookDetails.book_id}/?is_novel=1`
      ).then((res) => {
        setDailyBonusData(res)
      })
  }, [])

  const isMobile = window.screen.width < 600
  
  return (
    <>
      <CountryPopup
        isCountryPopupOpen={isCountryPopupOpen}
        toggleCountryPopup={toggleCountryPopup}
        user={user}
        onUpdateUser={onUpdateUser}
        novelApply={novelApply}
        book={bookDetails}
      />
      <BookCard>
        <TopSection>
          <Image
            onClick={() =>
              history.push(
                `${menuItemObj.novels}/id/${bookDetails.book_id}?tab=draft`
              )
            }
            width={[40, 112]}
            height={[60, 168]}
            mr={[8, 24]}
            src={bookDetails.image_url}
          />
          <DetailsDiv>
            {!isMobile && (
              <Text {...title}>
                {!isNonIndianAndNonUSUser &&
                  !isPublished &&
                  isNotApplied &&
                  !isLanguageNotAllowedForWBP &&
                  `Next Step - Publish your ${
                    bookDetails.application_threshold == 15000
                      ? 'series'
                      : 'novel'
                  }`}
                {!isNonIndianAndNonUSUser &&
                  isPublished &&
                  isNotApplied &&
                  !isLanguageNotAllowedForWBP &&
                  !bookDetails.is_eligible &&
                  `Next Step - Complete ${bookDetails.application_threshold} Words`}
                {!isNonIndianAndNonUSUser &&
                  isPublished &&
                  isNotApplied &&
                  !isLanguageNotAllowedForWBP &&
                  bookDetails.is_eligible &&
                  dateCheck &&
                  "Next Step - Apply for the Writer’s Benefit Program"}
                {isPublished && isPending && 'Your Application is submitted'}
                {isPublished && isApproved && 'Your Application is Approved'}
              </Text>
            )}
            <BookTitle>{bookDetails.book_title}</BookTitle>
            <AuthorName>{author_name}</AuthorName>

            {!isMobile && (
              <ActionButtons
                bookDetails={bookDetails}
                history={history}
                isNonIndianAndNonUSUser={isNonIndianAndNonUSUser}
                viewApplication={viewApplication}
              />
            )}
            {!isMobile && bookDetails?.daily_tracker?.chapter_missed && (
              <Timer />
            )}
          </DetailsDiv>
        </TopSection>
        {isMobile && bookDetails?.daily_tracker?.chapter_missed && <Timer />}
        {isMobile && (
          <ActionButtons
            bookDetails={bookDetails}
            history={history}
            isNonIndianAndNonUSUser={isNonIndianAndNonUSUser}
            viewApplication={viewApplication}
          />
        )}
        {isMobile && (isNotApplied || isCreated || isEligible) && (
          <ProgressBar
            book={bookDetails}
            isNonIndianAndNonUSUser={isNonIndianAndNonUSUser}
            toggleCountryPopup={toggleCountryPopup}
            toggleApplySnack={toggleApplySnack}
            novelApply={novelApply}
          />
        )}

        {!isLanguageNotAllowedForWBP && (
          <CautionNote
            bookDetails={bookDetails}
            isNonIndianAndNonUSUser={isNonIndianAndNonUSUser}
            signingStatus={signingStatus}
            history={history}
            viewApplication={viewApplication}
          />
        )}
        {!isMobile && (isNotApplied || isCreated || isEligible) && (
          <ProgressBar
            book={bookDetails}
            isNonIndianAndNonUSUser={isNonIndianAndNonUSUser}
            toggleCountryPopup={toggleCountryPopup}
            toggleApplySnack={toggleApplySnack}
            novelApply={novelApply}
          />
        )}
        {!eligibleForIncentive && isOngoing && (
          <Stats
            views={bookDetails.stats && bookDetails.stats.total_views}
            chapters={bookDetails.chapters_count}
            words={bookDetails.word_count}
            likes={bookDetails?.stats?.likes}
            comments={bookDetails?.stats?.comments}
          />
        )}
      </BookCard>

      {/* Daily Bonus Cards */}
      {/* Based on Daily Bonus Data */}
      {!!(eligibleForIncentive && dailyBonusData) && (
        <DailyBonusCard
          bookDetails={bookDetails}
          dailyBonusData={dailyBonusData}
        />
      )}

      {/* Ongoing but Incentive Disabled */}
      {isOngoing &&
        !eligibleForIncentive &&
        (bookDetails?.is_novel === 2 ? (
          <SeriesPerformanceCard bookId={bookDetails.book_id} user={user} bookDetails={bookDetails}/>
        ) : (
          <PerformanceCard bookId={bookDetails.book_id} user={user} bookDetails={bookDetails}/>
        ))}
      {applySnack && (
        <AlertSnackBar
          close={() => toggleApplySnack(false)}
          text="Sorry, the book doesn't match the editorial guidelines of the platform"
        />
      )}
    </>
  )
}

export default NewBookCards
